export enum SparePartCondition {
  NEW = 'New',
  RECONDITIONED = 'Reconditioned',
  USED = 'Used',
}
